import { CurrencyPipe, PlatformLocation } from '@angular/common';
import { Component, NgZone, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';
import { ToastController } from 'src/app/components/ionic-replacements/ToastController';
import { NavControllerExt } from 'src/app/extensions/nav-controller-extension';
import { CheckoutCommon } from 'src/app/pages/_brand-pages-base/base-controllers/checkout/checkout-common';
import { CalculateProvider } from 'src/app/providers/calculate/calculate';
import { CartProvider } from 'src/app/providers/cart/cart';
import { EventStreamerProvider } from 'src/app/providers/event-stream';
import { FunnelSettingsProvider } from 'src/app/providers/funnel-settings';
import { GeneralProvider } from 'src/app/providers/general';
import { LoggingProvider } from 'src/app/providers/logging';
import { OrderDetailsProvider } from 'src/app/providers/order-details/order-details';
import { OrderProvider } from 'src/app/providers/order/order';
import { OrderProviderExtender } from 'src/app/providers/order/order-extender';
import { PaypalPaymentExtenderProvider } from 'src/app/providers/paypal/paypal-extender';
import { SpinnerProvider } from 'src/app/providers/spinner/spinner';
import { StateProvider } from 'src/app/providers/state';
import { TouchcrApiCouponProvider } from 'src/app/providers/touchcr-api-coupon/touchcr-api-coupon';
import { TouchcrApiGeneralExtenderProvider } from 'src/app/providers/touchcr-api-general/touchcr-api-general-extender';
import { TouchcrApiLeadProvider } from 'src/app/providers/touchcr-api-lead/touchcr-api-lead';
import { TouchcrApiOrderExtenderProvider } from 'src/app/providers/touchcr-api-order/touchcr-api-order-extender';
import { TouchcrApiOrderformProvider } from 'src/app/providers/touchcr-api-orderform/touchcr-api-orderform';
import { TouchcrApiRemoteServicesProvider } from 'src/app/providers/touchcr-api-remoteservices';
import { TouchcrApiShippingProvider } from 'src/app/providers/TouchcrApiShippingProvider';
import { UrlsProvider } from 'src/app/providers/urls';
import { DynamicCurrencyPipe } from 'src/app/shared/pipes/dynamic-currency.pipe';
import { CDN_IMAGES, EXTERNAL_URLS, FREE_SHIPPING_OVER_AMOUNT, PHONE_NUMBER_AREA_CODE, PHONE_NUMBER_WITHOUT_AREA_CODE } from 'src/constants/param-constants';

@Component({
  selector: 'checkout-common-tc',
  templateUrl: './checkout-commonTC.html',
  styleUrls: ['./checkout-commonTC.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckoutCommonTC extends CheckoutCommon {
  public cdnImages = CDN_IMAGES;
  
  public override isSelectedCB2: boolean = true;
  override iconPaypal: string = EXTERNAL_URLS.PAYPAL_BUTTON_LARGE;

  public override guaranteeImage: string = `/assets/img/90-day.png`;
  public guaranteeImageWebp: string = `/assets/img/90-day.webp`;
  public trophyImage: string = `/assets/img/trophy.png`;
  public trophyImageWebp: string = `/assets/img/trophy.webp`;
  public truckImage: string = `/assets/img/truck.png`;
  public truckImageWebp: string = `/assets/img/truck.webp`;
  
  constructor(
    public override navCtrl: NavControllerExt,
    public override sanitizer: DomSanitizer,
    public override tcrApiOrderform: TouchcrApiOrderformProvider,
    public override cart: CartProvider,
    public override tcrApi: TouchcrApiGeneralExtenderProvider,
    public override tcrApiOrder: TouchcrApiOrderExtenderProvider,
    public override tcrApiRemoteServices: TouchcrApiRemoteServicesProvider,
    public override toastCtrl: ToastController,
    public override eventStreamer: EventStreamerProvider,
    public override tcrApiLead: TouchcrApiLeadProvider,
    public override tcrApiCoupon: TouchcrApiCouponProvider,
    public override orderDetails: OrderDetailsProvider,
    public override paypalPayment: PaypalPaymentExtenderProvider,
    public override ngZone: NgZone,
    public override shippingProvider: TouchcrApiShippingProvider,
    public override calculateHelper: CalculateProvider,
    public override urlsHelper: UrlsProvider,
    public override orderHelper: OrderProvider,
    public override orderHelperExtender: OrderProviderExtender,
    public override stateProvider: StateProvider,
    public override general: GeneralProvider,
    public override funnelProvider: FunnelSettingsProvider,
    public override spinner: SpinnerProvider,
    public override location: PlatformLocation,
    public override loggingProvider: LoggingProvider,
    public override currencyPipe: CurrencyPipe,
    public override router: Router,
    public override dynamicCurrencyPipe: DynamicCurrencyPipe,
    public override storage?: Storage
  ) {
    super(
      navCtrl,
      sanitizer,
      tcrApiOrderform,
      cart,
      tcrApi,
      tcrApiOrder,
      tcrApiRemoteServices,
      toastCtrl,
      eventStreamer,
      tcrApiLead,
      tcrApiCoupon,
      orderDetails,
      paypalPayment,
      ngZone,
      shippingProvider,
      calculateHelper,
      urlsHelper,
      orderHelper,
      orderHelperExtender,
      stateProvider,
      general,
      funnelProvider,
      spinner,
      location,
      loggingProvider,
      currencyPipe,
      router,
      dynamicCurrencyPipe,
      storage
    );
  }
  
  //Use this method to set up initial values for template variables
  override populatePageData() {
    let body = document.getElementsByTagName('body')[0];
    body.setAttribute('data-qa','checkout-page');

    this.headerText = '';
    this.showOnOrderForm = true;

    this.setDynamicCustomerServiceInfo();

    if (this.braintreeDefaultCountry && this.braintreeDefaultCountry == 'Germany') {
      this.headerText = `<h2 class="header-text__title no-padding">KUNDENDIENST</h2><p class="header-text__description">+1 (${PHONE_NUMBER_AREA_CODE}) ${PHONE_NUMBER_WITHOUT_AREA_CODE} | MF 7:00–17:00 UHR PST | SS 7:00–16:00 UHR PST</p>`;
    } else if (this.braintreeDefaultCountry && this.braintreeDefaultCountry == 'Mexico') {
      this.headerText = `<h2 class="header-text__title no-padding">Servicio al cliente</h2><p class="header-text__description">(800) 611-9075 |M-F 7AM-5PM PST | S-S 7AM-4PM PST</p><p class="header-text__description">servicioalcliente@terramare.com</p>`;
    } else {
      if (this.braintreeDefaultCountry && this.braintreeDefaultCountry != 'United States') {
        this.headerText = '<br><h2 class="header-text__title no-padding">CUSTOMER SERVICE</h2>' +
          `<p class="header-text__description">${this.dynamicPhoneNumber}<br>${this.dynamicCustomerServiceHours}</p>`;
      } else {
        this.headerText = '<h2 class="header-text__title no-padding">Free Shipping</h2>' +
          `<p class="header-text__description">U.S. Orders Over ${FREE_SHIPPING_OVER_AMOUNT}</p>` +
          `<h2 class="header-text__title">Customer Service (${PHONE_NUMBER_AREA_CODE}) ${PHONE_NUMBER_WITHOUT_AREA_CODE}</h2>` +
          `<p class="header-text__description">${this.dynamicCustomerServiceHours}</p>`;
      }
    }
    this.showOnOrderForm = true;
  }

  override async payPalAddressHandler(payload: any) {
    console.log('[GH] payPalAddressHandler v2 - issue with email validation that did not happen in the original checkout-common');
    await super.payPalAddressHandler(payload);
    try {
      if (this.accountForm?.form?.controls?.email) {
        this.accountForm.form.controls.email.updateValueAndValidity(); // DEV-46966
      }
    } catch (error) {
      console.error('[GH] Error updating email validity:', error);
    }
  }
} 